import { connect } from "react-redux";
import { Dispatch } from "redux";
import CloudFoundryBanner from "../common/components/CloudFoundryBanner";
import * as actions from "../common/actions";
import { KeyValue } from "../interfaces";

function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateBanner: (banner: string) => {
      dispatch(actions.updateBanner(banner));
    },
    updateUi: (uiField: string, uiValue: string | KeyValue[] | undefined) => {
      dispatch(actions.updateUi(uiField, uiValue));
    },
  };
}
export default connect(null, mapDispatchToProps)(CloudFoundryBanner);
